<template>
    <button
        class="pb-2 text-end mb-2 ml-auto d-block"
        :disabled="!orderTravelers.length"
        :class="{'text-link': orderTravelers.length}"
        @click="modal = true"
    >
        <v-icon>mdi-open-in-new</v-icon>
        {{ $t('trip_assistant_link') }}
    </button>
    <v-dialog v-model="modal" max-width="412" @close="modal = false">
        <v-card class="py-4">
            <v-btn
                icon="mdi-close"
                variant="text"
                size="small"
                class="close-btn ml-auto"
                data-cy="close"
                @click="modal = false"
            />
            <v-card-text class="px-4 px-sm-5">
                <div v-if="newUrl">{{ newUrl }}</div>
            </v-card-text>
            <v-card-actions class="justify-start px-2 px-sm-3" @click="copyToBuffer">
                <v-btn variant="text" size="small" color="primary">
                    {{ $t('copy') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
    import CryptoJS from 'crypto-js'
    import Clipboard from 'clipboard-copy'

    const props = defineProps<{
        orderId: string | number
        orderTravelers: any[]
    }>()

    const modal = ref<boolean>(false)
    const tripAssistantKey = ref<string>(null)
    const newUrl = ref<string>(null)

    const app = useNuxtApp()

    watch(modal, async () => {
        if (modal.value) {
            await generateLink()
        }
    })

    const generateRandomKey = length => {
        const randomBytes = CryptoJS.lib.WordArray.random(length)
        return randomBytes.toString(CryptoJS.enc.Hex)
    }

    const generateLink = async () => {
        const randomKey = generateRandomKey(16)
        tripAssistantKey.value = randomKey
        await app.$api.tripAssistant.post({
            orderId: props.orderId,
            key: randomKey,
        })
        await generateNewUrl()
    }

    const generateNewUrl = async () => {
        const traveler = props.orderTravelers.find(({isChild}) => !isChild).name?.[0]
        const travelerName = `${traveler.firstName} ${traveler.lastName}`.trim()
        newUrl.value = `${window.location.origin}/tripAssistant/${props.orderId}/${encodeURIComponent(travelerName)}?key=${tripAssistantKey.value}`
    }

    const copyToBuffer = async () => {
        try {
            await Clipboard(newUrl.value)
        } catch (err) {
            console.error(err)
        }
    }
</script>
